import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { OrdersComponent } from './orders.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem } from '@nebular/theme';
import { SalesOrderComponent } from './sales-order/sales-order.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order.component';

export const ordersroutes: Routes = [
  /* {
    path:'',
    component:OrdersComponent,
    data:{
      breadcrumb:"Orders",
    }
  }, */
  {
    path:'sales',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Orders",
    }
  },
  {
    path:'sales/order/:orderId/:statusId/:partyId/order-overview/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId"
    }
  },
  {
    path:'sales/order/:orderId/:statusId/order-items/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId"
    }
  },
  {
    path:'sales/order/:orderId/:statusId/order-adjustments/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId"
    }
  },
  {
    path:'sales/order/:orderId/:statusId/order-payments/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId"
    }
  },
  {
    path:'sales/order/:orderId/:partyId/customer-info/:subMenuItem/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId"
    }
  },
  {
    path:'sales/order/:orderId/:statusId/delivery-schedule/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId",
      type:"Order Delivery Schedule"
    }
  },
  {
    path:'sales/order/:orderId/:statusId/ship-groups/:event',
    component:SalesOrderComponent,
    data:{
      breadcrumb:"Sales Order: ",
      paramKey:"orderId",
      type:"Order Delivery Schedule"
    }
  },
  {
    path:'purchases',
    component:PurchaseOrderComponent
  },
  {
    path:'purchases/order/:orderId',
    component:PurchaseOrderComponent
  },
  { path: '', redirectTo: 'sales', pathMatch: 'full' },
]

const MENU_ITEMS:NbMenuItem[] = [
  {title:"Orders",group:true},
    {
        title:"Sales",
        children:[
            {
              title:"List Orders",
              icon:"list-outline",
              link:"/admin/orders/sales",
              data:{
                event:"list",
                type:"OrderList",
                appContext:"orders",
              }
            },
            {title:"New Sales Order",icon:"plus-outline"},
        ]
    },
    {
        title:"Purchases",
        children:[
            {title:"List Orders",icon:"list-outline",link:"/admin/orders/purchases"},
            {title:"New Purchase Order",icon:"plus-outline"},
        ]
    }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(ordersroutes),
    UbsViewContainersModule
  ]
})

export class OrdersRoutingModule { 
  headerTitle:string = "Orders Management";
  path:string = "orders";
  menuTag:string = "ordersMenu"
  menuAndTitleOptions = {path:this.path,menuItems:MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};

  constructor(private viewContainerService:ViewContainersService){
    console.log("UpdateMenuTitle",this.menuAndTitleOptions)
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
  }
}
